import React, { useState } from 'react';
import helper from 'services/helper';

function DatePicker({
  value = null,
  onChange = () => console.log('onChange!'),
}) {

  const handleMonthChange = (e) => {
    console.log("🚀 ~ handleMonthChange ~ e.target.value:", e.target.value)
    onChange(e.target.value);
  };

  return (
    <div className="control-group">
      <input
        type="month"
        value={value}
        onChange={(e) => handleMonthChange(e)}
      />
      {/* {value && (
        <div>
          <p>เลือก: {helper.FN.mapYearMonthLang(value, "th")}</p>
        </div>
      )} */}
    </div>
  );
}

export default DatePicker;
